import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { paymentHistory } from '../../../api-services';
import Pagination from '../../../helper/Pagination';
import BarLoader from 'react-bar-loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
const PaymentHistory = () => {
  const [page, setPage] = useState(1);

  const {
    isFetching,
    refetch,
    isLoading,
    data: paymentHistoryData,
  } = useQuery(
    'paymentHistory',
    () =>
      paymentHistory({
        page: page,
      }),
    {
      refetchOnWindowFocus: false,
    },
  );

  const onChangePage = async (page) => {
    setPage(page);
  };

  useEffect(() => {
    refetch();
  }, [page]);

  const handleDuration = (duration) => {
    switch (duration) {
      case 'M':
        return 'Monthly';
      case 'Q':
        return 'Quarterly';
      case 'H':
        return 'Half Yearly';
      case 'Y':
        return 'Yearly';

      default:
        return '---';
    }
  };
  return (
    <>
      <div className="page_content">
        <section className="lower_section pt-2">
          <div className="page_heading page_heading_enhence d-flex justify-content-between align-items-center w-100 bg-white p-2">
            <h3>
              <span className="title">Call History</span>
            </h3>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center justify-content-center  reload_icon"
              onClick={() => refetch()}
            >
              <FontAwesomeIcon icon={faRefresh} />
            </button>
          </div>
          <div className="row">
            <div className="col-md-12 ">
              <div className=" table-responsive position-relative">
                {(isLoading || isFetching) && (
                  <div className="custom-linear-loader-row">
                    <div className="custom-linear-loader" colSpan="11">
                      <BarLoader color="#000000" height="4px" />
                    </div>
                  </div>
                )}
                <table className="table table_custom table_custom_enhence  mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Date
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Name
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Type
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Cost
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Status
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Duration
                      </th>

                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Free mins
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Free SMS
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Comment
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Tax
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Security charge
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Card Process Fee
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {paymentHistoryData &&
                    paymentHistoryData.data &&
                    paymentHistoryData.data.data &&
                    paymentHistoryData.data.data.length > 0 ? (
                      paymentHistoryData.data.data.map((val, index) => {
                        const {
                          plan_name,
                          type,
                          plan_cost,
                          status,
                          plan_duration,
                          free_mins,
                          free_sms,
                          plan_comment,
                          security_charge,
                          card_process_fee,
                          plan_tax,
                          created_at,
                        } = val;

                        return (
                          <tr key={index}>
                            <td align="center" style={{ width: '8.3%' }}>
                              {created_at ? created_at : '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {plan_name ? plan_name : '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {type === 'P' ? 'Paid' : 'Free'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {plan_cost ? plan_cost : '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {status === 'A' ? 'Activated ' : 'Deactivated'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {handleDuration(plan_duration)}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {free_mins}
                            </td>

                            <td align="center" style={{ width: '8.3%' }}>
                              {free_sms}
                            </td>

                            <td align="center" style={{ width: '8.3%' }}>
                              {plan_comment ? plan_comment : '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {plan_tax ? plan_tax : '---'}
                            </td>

                            <td align="center" style={{ width: '8.3%' }}>
                              {security_charge ? security_charge : '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {card_process_fee ? card_process_fee : '---'}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" align="center">
                          No Record Found{' '}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 m-0 pagingWrap p-0 d-flex justify-content-between align-items-center">
                {paymentHistoryData &&
                paymentHistoryData.data &&
                paymentHistoryData.data.data &&
                paymentHistoryData.data.data.length > 0 ? (
                  <>
                    <div className="text-black d-flex align-items-center total_records justify-content-center">
                      Total
                      <span className="d-flex  mr-2 align-items-center  btn-primary  btn-sm ml-2">
                        {paymentHistoryData?.data?.totalRecords}
                      </span>
                      record(s)
                    </div>
                    <div>
                      <Pagination
                        pageSize={paymentHistoryData?.data?.lastPage}
                        items={paymentHistoryData?.data?.data}
                        onChangePage={onChangePage}
                        total={paymentHistoryData?.data?.totalRecords}
                        currentPage={page}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PaymentHistory;
